module.exports = __webpack_public_path__ + "static/media/pessoaFazendoLogin.eed901dc.svg";